import React, { useState } from 'react'
import NoteTemplateForm from '../note-template-form/NoteTemplateForm'
import NoteTemplateService from '../../../../../services/api/note-template.service'
import APIResponse from '../../../../templates/components/APIResponse'
import DimLoader from '../../../../templates/components/DimLoader'

const NoteTemplateAdd = (props) => {
    const { onClose, refresh } = props;
    const [isLoader, setIsLoader] = useState(false)
    const [apiResponse, setApiResponse] = useState()

    const onSuccess = (message) => {
        if (props.refresh) {
            props.refresh()
        }
        if (props.onClose) {
            props.onClose()
        }
        if (props.exitHandler) {
            props.exitHandler()
        }
    }

    const submitHandler = (data) => {
        let reqObj = { ...data }
        
        // Set NotesType to 1 (hardcoded as per requirements)
        reqObj.notesType = 1;
        
        // Remove practiceLocationId if undefined/null/empty
        if (reqObj.practiceLocationId === undefined || reqObj.practiceLocationId === null || reqObj.practiceLocationId === '') {
            delete reqObj.practiceLocationId
        }
        
        setIsLoader(true)
        NoteTemplateService.addNoteTemplate(reqObj)
            .then(response => {
                setApiResponse(response)
                setIsLoader(false)
            })
            .catch(error => {
                setApiResponse(error)
                setIsLoader(false)
            })
    }

    return (
        <>
            {isLoader && <DimLoader loadMessage="Processing" />}
            <NoteTemplateForm 
                submitHandler={submitHandler} 
                onClose={() => props.onClose()} 
                refresh={refresh}
                initialData={{}} 
            />
            <APIResponse apiResponse={apiResponse} onSuccess={onSuccess} toastOnSuccess={true} />
        </>
    )
}

export default NoteTemplateAdd
